<div class="row">
  <div class="col-sm-6">
    <h2>Chains</h2>
  </div>
  <div class="col-sm-4">
    <input
      style="float: right; background-color: white"
      type="text"
      placeholder="Search by name..."
      nbInput
      [(ngModel)]="word"
      (keyup)="onFilterKeySearch()"
    />
  </div>
  <div class="col-sm-2">
    <button *ngIf="role === 'admin'" type="button" class="btn btn-primary px-4" style="float: right" (click)="addChain()">
      Add Chain
    </button>
  </div>
</div>

<div class="col-12" style="margin-top: 20px">
  <nb-card>
    <nb-card-body>
      <table class="table text-center">
        <thead>
          <tr>
            <th scope="col">S.No.</th>
            <th scope="col">Chain Name</th>
            <th scope="col">Description</th>
            <th scope="col"># Stores</th>
            <th scope="col">Status</th>
            <th scope="col">Created</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let chain of filteredChains
                | paginate: { itemsPerPage: count, currentPage: page, totalItems: total };
              let i = index
            "
          >
            <td>{{ (page - 1) * count + i + 1 }}</td>
            <td>{{ chain.chainName }}</td>
            <td>{{ chain.description || '-' }}</td>
            <td>{{ chain.storeIds?.length || chain.storeCount || 0 }}</td>
            <td>
              <nb-badge
                [text]="getStatusText(chain.status)"
                [status]="getStatusBadge(chain.status)"
              ></nb-badge>
            </td>
            <td>{{ chain.createdAt | date: 'dd/MM/yyyy' }}</td>
            <td>
              <nb-icon
                style="cursor: pointer"
                (click)="editChain(chain._id)"
                class="right"
                icon="edit-outline"
                nbTooltip="Edit Chain"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer"
                (click)="viewOverview(chain._id)"
                class="right"
                icon="grid-outline"
                nbTooltip="Chain Overview"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer"
                (click)="viewReports(chain._id)"
                class="right"
                icon="bar-chart-outline"
                nbTooltip="View Reports"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer"
                (click)="deleteChain(chain._id, chain.chainName)"
                class="right deleteIcon"
                icon="trash-outline"
                nbTooltip="Delete Chain"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer; color: #0095ff"
                (click)="goToBranding(chain._id)"
                class="right"
                icon="color-palette-outline"
                nbTooltip="Chain Branding"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer; color: #0095ff"
                (click)="goToCatalog(chain._id)"
                class="right"
                icon="shopping-cart-outline"
                nbTooltip="Chain Catalog"
              ></nb-icon>
              <nb-icon
                style="cursor: pointer; color: #0095ff"
                (click)="goToLoyalty(chain._id)"
                class="right"
                icon="award-outline"
                nbTooltip="Chain Loyalty"
              ></nb-icon>
            </td>
          </tr>
          <tr *ngIf="filteredChains.length === 0">
            <td colspan="7" class="text-center" style="padding: 30px; color: #888">
              No chains found.
            </td>
          </tr>
        </tbody>
      </table>
      <pagination-controls
        class="pagination"
        [responsive]="true"
        (pageChange)="pageChanged($event)"
        previousLabel="Prev"
        nextLabel="Next"
      ></pagination-controls>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
